import React, { Fragment } from "react";
import Grid from "@mui/material/Grid";
import Title from "./elements/Title";
import WelcomeMsg from "./elements/WelcomeMsg";

import {
  HomeBannerContainer,
  HomeTitleBox,
} from "./styled/HomeBanner.styled";
export default function HomeBanner({ small, ...props }) {
  return (
    <Fragment>
      <HomeBannerContainer small={small}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6}>
            <HomeTitleBox>
              <Title />
              <WelcomeMsg />
            </HomeTitleBox>
          </Grid>
          <Grid item xs={12} md={6}></Grid>
        </Grid>
      </HomeBannerContainer>
    </Fragment>
  );
}
